
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../ui/accordion";



const FAQ = () => {
  const faqs = [
    {
      question: "Can I cancel anytime?",
      answer: "Yes, you can cancel at any time and for any reason."
    },
    {
      question: "Are there any contracts or hidden fees?",
      answer: "We don't have any contracts or hidden fees. Because we don't lock you into a contract, you're free to cancel anytime if you choose to leave."
    },
    {
      question: "Are there any fees for SMS/email appointment notifications?",
      answer: "Nope. Nada. Nyet. 🙂 All plans include unlimited SMS/email appointment confirmations and reminders."
    },
    {
      question: "Can I use my own credit card processor?",
      answer: "You can use your own credit card processor instead of, or in addition to Feelaxo Pay. However, many advanced features (Express Booking™, self checkout, cards-on-file, deposits, etc) will not be available."
    },
    {
      question: "Who counts as a service provider?",
      answer: "Only staff members that provide services are counted. Front desk staff, owners, or managers can have their own logins and do NOT count towards the totals."
    },
    {
      question: "Do you offer one-on-one demos?",
      answer: "Yes, we'd love to show you the platform in a personalized, guided demo. Someone from our team will call you and send you a link for screensharing. Schedule now."
    },
    {
      question:"Can I transfer data from my old system?",
      answer:"Yes! We can transfer clients, products, and gift cards, and in many cases additional things like notes, services, transaction and appointment history. A dedicated specialist will work with you to map out what data can be migrated and help build a plan for anything that needs to be recreated—and for free!"
    },
    {
      question:"Do you support booth renter/hybrid models?",
      answer:"Yes. We offer unique booking links, multiple payment accounts, client ownership settings, and the ability for your renters to sell their own products all under a single Mangomint account."
    }
  ];

  return (
    <div className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-lg px-6 border-0 shadow-sm hover:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
